import { clientSide } from '../../components/Settings/ePassport/config_react.js'
import { config } from '../../../config.js'

const { redirectToStorage } = clientSide[0]
const API = config.apiUrl

export function addFile(file) {
    return {
        type: 'ADD_FILE',
        file,
    }
}

export function removeFile(file) {
    return {
        type: 'REMOVE_FILE',
        file,
    }
}

export function addServices(arr) {
    return {
        type: 'ADD_SERVICES',
        arr,
    }
}

export function addFilesList(obj) {
    return {
        type: 'ADD_FILES_LIST',
        obj,
    }
}

export function addFilesOther(arr) {
    return {
        type: 'ADD_FILES_OTHER',
        arr,
    }
}

export function UserData(type, obj) {
    switch (type) {
        case 'ADD_USER_DATA':
            return {
                type: 'ADD_USER_DATA',
                obj,
            }
            break
        case 'TFA_SESSION_TIMEOUT':
            return {
                type: 'TFA_SESSION_TIMEOUT',
                obj,
            }
            break
        case 'WRONG_TFA_CODE':
            return {
                type: 'WRONG_TFA_CODE',
                obj,
            }
            break
        case 'CLEANING_USER_STATE':
            return {
                type: 'CLEANING_USER_STATE',
                obj
            }
    }
}

export function getPersonalData(code) {
    return dispatch => {
        fetch(`${API}ui/investor_settings/get_personaldata?2fa_code=${code}`, {
            method: 'GET',
            headers: {},
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    dispatch(getUserData(data))
                } else {
                    if (data.error === '2fa_session_timeout') {
                        dispatch(UserData('TFA_SESSION_TIMEOUT', data))
                    } else if (data.error === 'wrong_2fa_code') {
                        dispatch(UserData('WRONG_TFA_CODE', data))
                    }
                }
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }
}

export function getUserData(personalData) {
    return dispatch => {
        fetch(`${API}ui/investor_settings/get_userdata`, {
            method: 'GET',
            headers: {},
            cache: 'no-store',
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    dispatch(
                        UserData(
                            'ADD_USER_DATA',
                            Object.assign({}, data, personalData, {
                                success: {
                                    userData: data.success,
                                    personalData: personalData.success,
                                },
                            })
                        )
                    )
                }
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }
}

export function getServices(address) {
    console.log('getServices', address)
    return dispatch => {
        fetch(`${redirectToStorage}/pagetservices`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(items => {
                let itemsArr = JSON.parse(items.services_list)
                if (itemsArr.length > 0) {
                    let arr = []
                    itemsArr.forEach((item, i) => {
                        arr.push({
                            id: item.eth_address,
                            name: item.firstname,
                        })
                    })
                    dispatch(addServices(arr))
                }
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }
}

export function getFiles() {
    return dispatch => {
        fetch(`${redirectToStorage}/pagetfilelist`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                console.log('getFiles 1', response)
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(items => {
                console.log('getFiles 2', items)
                let itemsArr = items.file_list
                console.log('getFiles 3', itemsArr)
                if (itemsArr.files.length === 0) {
                    dispatch(
                        addFilesList({
                            passport: '',
                            account_statement: '',
                            registration: '',
                            ownership: '',
                        })
                    )
                    dispatch(addFilesOther([]))
                    console.log('getFiles 4')
                }
                if (itemsArr.files.length > 0) {
                    let arrOther = []
                    let dataObject = {
                        passport: '',
                        account_statement: '',
                        registration: '',
                        ownership: '',
                    }
                    itemsArr.files.forEach(item => {
                        if (item.fileType !== 'other') {
                            Object.assign(dataObject, {
                                [item.fileType]: item,
                            })
                        } else {
                            arrOther.push(item)
                        }
                    })
                    dispatch(addFilesList(dataObject))
                    dispatch(addFilesOther(arrOther))
                    console.log('getFiles 5')
                }
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }
}
